import CheckIcon from '@mui/icons-material/Check'
import Button from '@mui/material/Button'
import { useCiboAutoForm } from './CiboAutoFormContext'

export interface SubmitFieldProps {
  value?: string
  label?: string
  disabled?: boolean
  [key: string]: unknown
}

export function SubmitField({ disabled: disabledProp, ...rest }: SubmitFieldProps) {
  const { disabled, errors, hasExistingModel, isDirty, isTouched, submitting } = useCiboAutoForm()

  const hasErrors = errors.length > 0
  const shouldShowUpdate = Boolean(hasExistingModel && isDirty)
  const shouldShowSaved = Boolean(hasExistingModel && !shouldShowUpdate)
  const buttonText = hasExistingModel ? (shouldShowUpdate ? 'Update' : 'Saved') : 'Save'

  return (
    <Button
      type="submit"
      variant="contained"
      loading={submitting}
      disabled={Boolean(disabledProp || disabled || submitting || hasErrors || shouldShowSaved)}
      endIcon={shouldShowSaved ? <CheckIcon /> : undefined}
      {...rest}
    >
      {buttonText}
    </Button>
  )
}
